import { render, staticRenderFns } from "./Dealer.vue?vue&type=template&id=46f54a1c&"
import script from "./Dealer.vue?vue&type=script&lang=js&"
export * from "./Dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports